/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { Typography } from "@mui/material";
import { usePopup } from "@nodeon/react-components";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  OrganizationDetailsDto,
  useOrganizationApi,
  UserListDto,
} from "~/api/GeneratedApi";
import GenericTable from "~/components/GenericTable";
import OrganizationUserEditDialog from "../dialogs/OrganizationUserEditDialog";
import OrganizationUserMoveDialog from "../dialogs/OrganizationUserMoveDialog";

interface Props {
  organizationData: OrganizationDetailsDto;
}

const OrganizationUsersTable = ({ organizationData }: Props): JSX.Element => {
  const { t } = useTranslation("organization-management");

  const organizationApi = useOrganizationApi();

  const { show } = usePopup();
  const refetchRef = useRef<() => void>();

  return (
    <GenericTable<UserListDto>
      columns={[
        {
          title: t("name"),
          field: "name",
        },
        {
          title: t("role"),
          field: "organizationRoles",
          render: (rowData) => {
            return rowData.organizationRoles?.map((r) => {
              return <Typography key={r.id}>{r.roleName}</Typography>;
            });
          },
        },
        {
          title: t("general:email"),
          field: "email",
        },
      ]}
      fetch={(opts) =>
        organizationApi.getOrganizationUsers(organizationData.id, opts)
      }
      getRefetch={(r) => {
        refetchRef.current = r;
      }}
      tableProps={{
        title: t("organizations-users", {
          organization: organizationData.name,
        }),
        actions: [
          /* {
            icon: "delete",
            tooltip: t("delete-user", { organization: organizationData.name }),
            onClick: (_, rowData) => {
              if ("length" in rowData) return;
              confirm({
                title: t("general:are-you-sure"),
                description: t("delete-user-popup-description", {
                  user: rowData.name,
                  organization: organizationData.name,
                }),
                icon: <DeleteIcon />,
              }).then(() => {
                organizationApi
                  .deleteOrganizationUser(organizationData.id, rowData.id)
                  .then(() => {
                    enqueueSnackbar(
                      t("user-deleted", {
                        user: rowData.name,
                        organization: organizationData.name,
                      }),
                      { variant: "success" },
                    );
                  })
                  .catch(handleApiError);
              });
            },
          }, */
          {
            icon: "add",
            tooltip: t("general:add"),
            isFreeAction: true,
            onClick: () =>
              show(
                <OrganizationUserMoveDialog
                  organizationId={organizationData.id}
                  onSubmitted={refetchRef.current}
                />,
                { noDialog: true },
              ),
          },
          {
            icon: "edit",
            tooltip: t("general:edit"),
            onClick: (_, rowData) => {
              if (Array.isArray(rowData)) return;
              show(
                <OrganizationUserEditDialog
                  organizationId={organizationData.id}
                  user={rowData}
                  onSubmitted={() => refetchRef.current?.()}
                />,
                { noDialog: true },
              );
            },
          },
        ],
      }}
    />
  );
};

export default OrganizationUsersTable;
